/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PermalinkButtonContainer_story = {
    readonly url: string;
    readonly " $refType": "PermalinkButtonContainer_story";
};
export type PermalinkButtonContainer_story$data = PermalinkButtonContainer_story;
export type PermalinkButtonContainer_story$key = {
    readonly " $data"?: PermalinkButtonContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkButtonContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkButtonContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'deba04bf041ab4bd2bcccd9d9dac28ff';
export default node;
